<template>
    <div class="modal fade" tabindex="-1" role="dialog" ref="modal">
        <div class="modal-dialog" :class="size === '' ? '' : `modal-${size}`" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">
                        <slot name="title"/>
                    </h5>
                    <!-- An optional button next to the title, e.g. the help of the dialog -->
                    <div v-if="$slots.help" class="ms-2">
                        <slot name="help"/>
                    </div>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <slot name="body"/>
                </div>
                <div class="modal-footer">
                    <slot name="buttons"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import {Modal} from 'bootstrap';
import {defineComponent, onMounted, PropType, ref} from 'vue';

export default defineComponent({
    props: {
        // Bootstrap size of the dialog: '' (default), 'sm', 'lg', 'xl'
        size: {
            type: String as PropType<'' | 'sm' | 'lg' | 'xl'>,
            default: '',
        },
    },
    emits: ['hidden'],
    setup(props, {expose, emit}) {
        const modal = ref<HTMLElement | null>(null);
        let modalInstance: Modal;

        function show(): void {
            modalInstance.show();
        }

        function hide(): void {
            modalInstance.hide();
        }

        // The field with autofocus takes the focus when the dialog is shown: Bootstrap focuses the dialog itself
        // after its transition, so a field focused earlier loses the focus again
        function focusField(): void {
            const field = modal.value?.querySelector<HTMLElement>('[autofocus]') ?? null;

            field?.focus();

            if (field instanceof HTMLInputElement) {
                field.select();
            }
        }

        onMounted(() => {
            modalInstance = new Modal(modal.value as HTMLElement);
            modal.value?.addEventListener('shown.bs.modal', focusField);
            modal.value?.addEventListener('hidden.bs.modal', () => emit('hidden'));
        });

        expose({show, hide});

        return {modal, show, hide};
    },
});
</script>
